import React from "react";
var __jsx = React.createElement;
import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-regular-svg-icons";
import { get } from "lodash";
import AwesomeIcon from "../AwesomeIcon";
import { t } from "i18next";
var invalidFileError = function invalidFileError(_ref) {
  var fileObject = _ref.fileObject;
  var res = fileObject.filter(function (item) {
    return !item.isValidated;
  });
  if (res.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start space-x-1 whitespace-break-spaces"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      size: "sm",
      name: faCircleXmark,
      className: "text-red-600"
    }), /*#__PURE__*/React.createElement("span", {
      className: "pl-2 text-red-600"
    }, get(res, [0, "inValidMessage"], "") || t("invalid_scan")));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start space-x-1 whitespace-break-spaces"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      size: "sm",
      name: faCircleCheck,
      className: "text-green-600"
    }), /*#__PURE__*/React.createElement("span", {
      className: "pl-2 text-green-600"
    }, t("valid_scan")));
  }
};
export default invalidFileError;